(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoController', ReporteEvaluativoController);

    ReporteEvaluativoController.$inject = ['$scope', '$state', 'ReporteEvaluativoService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService','downloadService','Periodos',
    	'AniosEscolares','ReporteProfesorService','ReporteAlumnoService','Instituciones','NivelesEducativosService','ModelosEducativosService'];

    function ReporteEvaluativoController ($scope, $state, ReporteEvaluativoService, ParseLinks, AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,downloadService,Periodos,
    		AniosEscolares,ReporteProfesorService,ReporteAlumnoService,Instituciones,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;
        
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
     
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=intercursoValue();
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
		
        cargarDropdrown();
        loadAll();

        vm.limpiar = limpiar;
        vm.generarReportesMasivos = generarReportesMasivos;
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	if (newValue !== oldValue) {        	
	        	vm.periodos = null;
				
	        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
	        		vm.periodos = Periodos.query({
	            		anio: vm.anioSeleccionado,
	            		dep: vm.institucionSelected,
	            		ic: vm.intercurso
	                }, onPeriodosSuccess);
	        	}
			}
        });
		
		function cargarDropdrown(){
			vm.aniosEscolares = AniosEscolares.query();
			vm.dependencias = Instituciones.query();
			vm.niveles = NivelesEducativosService.getAll();
			vm.modelos = ModelosEducativosService.getAll();
		}
        
        function loadAll () {
        	vm.periodos = null;
			
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                }, onPeriodosSuccess);
        	}
        	
        	ReporteEvaluativoService.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
        	
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onTransitionSuccess);
        }

        function search(){
        	if(vm.anioSeleccionado != null){
	        	$state.transitionTo($state.$current, {
	                page: 0,
	                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
	                search: vm.currentSearch,
	                type: vm.type,
	                indice: vm.indicePeriodo,
	                ic: vm.intercurso,
	                iic: vm.indiceIntercurso,
	                anio: vm.anioSeleccionado,
	                aniostr: vm.anioSeleccionado,
	                modelo: vm.modeloSeleccionado,
	                nivel: vm.nivelSeleccionado,
	                centro: vm.institucionSelected,
	                ep: vm.evaluacionesPendientes
	            },onSearchTransitionSuccess)
			}
        }
        
        function generarReportesMasivos(){
        	if(vm.anioSeleccionado==null || vm.anioSeleccionado==0  || vm.indicePeriodo == null || vm.intercurso == null || vm.indiceIntercurso == null || vm.modeloSeleccionado == null || vm.nivelSeleccionado == null|| vm.modeloSeleccionado == 0 || vm.nivelSeleccionado == 0 || vm.institucionSelected == null|| vm.institucionSelected == 0)
        		return ;
        	
        	ReporteEvaluativoService.reportesMasivos({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected
            }, onSuccess, onError);
        }
		
		function onSuccess(data, headers) {
		    vm.links = ParseLinks.parse(headers('link'));
		    vm.totalItems = headers('X-Total-Count');
		    vm.queryCount = vm.totalItems;
		    vm.wrappers = data;
		    vm.page = pagingParams.page;
		}
		
		function intercursoValue() {
			if (typeof pagingParams.ic === 'boolean') {
				return pagingParams.ic;
			}
			
			if(pagingParams.ic === 'true')
				return true;
			return false;
		}

		function onPeriodosSuccess(){
			if(vm.intercurso === true){
				vm.indicePeriodo = 0;
				vm.indiceIntercurso = pagingParams.iic;
			}else{
				vm.indicePeriodo = pagingParams.indice;
				vm.indiceIntercurso = 0;
			}
		}

		function onSearchTransitionSuccess(){
		}

		function onTransitionSuccess(){
		}

		function onError(error) {
		    AlertService.error(error.data.message);
		}
		

		function limpiar() {
			vm.modeloSeleccionado = null;
		}

		function sort() {
			var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
		    if (vm.predicate !== 'id') {
		    	result.push('id');
		    }
		    return result;
		}  
    }
})();
